module.exports = __webpack_public_path__ + "img/project-3.4d274782.jpg";